<div style="display: flex; justify-content: space-between; margin-bottom: 40px">
  <h2>{{ title }} Concepto de Capital</h2>
  <div style="display: flex">
    <button type="submit" mat-flat-button (click)="onSubmit()" style="margin-right: 20px" class="btn-success" [disabled]="form.invalid" appPermissionControl="P126B0001">
      <mat-icon>save</mat-icon>
      {{ title }}
    </button>
    <button mat-flat-button class="btn-back" (click)="close()" appPermissionControl="P126B0002">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>
</div>
<form [formGroup]="form" class="form-row" appPermissionControl="P126F0001">
  <!-- Capital -->
  <div class="form-field">
    <select formControlName="capital" class="form-control" appPermissionControl="P126K0001">
      <option [value]="null">Seleccionar Capital</option>
      <option *ngFor="let capital of capitales" [value]="capital.concepto">
        {{ capital.descripcion }}
      </option>
    </select>
    <label>Capital</label>
  </div>

  <!-- Intereses -->
  <div class="form-field">
    <select formControlName="intereses" class="form-control" appPermissionControl="P126K0002">
      <option [value]="null">Seleccionar Intereses</option>
      <option *ngFor="let interes of intereses" [value]="interes.concepto">
        {{ interes.descripcion }}
      </option>
    </select>
    <label>Intereses</label>
  </div>
</form>
